// Coque commune aux pages authentifiées : TopBar + navigation latérale.

import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { TopBar } from "./TopBar";
import { TrialBanner } from "./TrialBanner";
import { Footer } from "./Footer";

type Props = { children: React.ReactNode };

export function AppShell({ children }: Props) {
  const { t } = useTranslation();

  const NAV = [
    { to: "/", label: t("nav.home") },
    { to: "/uploads", label: t("nav.uploads") },
    { to: "/invoices", label: t("nav.invoices") },
    { to: "/sales", label: t("nav.sales") },
    { to: "/products", label: t("nav.products") },
    { to: "/suppliers", label: t("nav.suppliers") },
    { to: "/clients", label: t("nav.clients") },
    { to: "/projects", label: t("nav.projects") },
    { to: "/intervenants", label: t("nav.intervenants") },
    { to: "/reconciliation", label: t("nav.reconciliation") },
    { to: "/settings/billing", label: t("nav.billing") },
    { to: "/settings/company", label: t("nav.company") },
    { to: "/settings/members", label: t("nav.team") },
    { to: "/settings/audit", label: t("nav.audit") },
    { to: "/settings/reminder-rules", label: t("nav.reminderRules") },
    { to: "/settings/reminder-templates", label: t("nav.reminderTemplates") },
  ];

  return (
    <div className="min-h-screen bg-slate-50 flex flex-col">
      <TopBar />
      <TrialBanner />
      <div className="flex-1 w-full px-4 py-6 grid grid-cols-1 md:grid-cols-[180px_1fr] gap-6">
        <nav aria-label="Navigation principale" className="space-y-1">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === "/"}
              className={({ isActive }) =>
                [
                  "block rounded-md px-3 py-2 text-sm font-medium",
                  isActive
                    ? "bg-brand-500/10 text-brand-600"
                    : "text-slate-600 hover:bg-slate-100",
                ].join(" ")
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>
        <main>{children}</main>
      </div>
      <Footer />
    </div>
  );
}
